import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, HelpCircle } from 'lucide-react';
const faqs = [{
  q: 'What if my child is still melting down no matter what I do?',
  a: 'Then the goal is: shorter meltdowns + faster recovery + less escalation from you. The reset focuses on regulation first, not compliance first.'
}, {
  q: 'Is this gentle parenting or behavior management?',
  a: 'It’s regulation-based boundaries—warm, clear, and practical. Not permissive, not punishment-heavy.'
}, {
  q: 'What if I have multiple kids?',
  a: 'The reset is designed to be simple and repeatable so you can run it even with siblings. The Routine Pack upsell is best for multi-kid logistics.'
}, {
  q: 'I’m exhausted. Is this going to be a “whole routine” I can’t maintain?',
  a: 'No. The core is a 30-minute reset with a quick-start page—meant for real weekday energy.'
}, {
  q: 'Will this work if my child has ADHD/anxiety/sensory needs?',
  a: 'Many families find regulation-first approaches especially helpful. These are supportive routines designed to work alongside professional guidance.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 md:px-6 bg-cream-50" data-id="element-29">
      <div className="max-w-3xl mx-auto" data-id="element-30">
        <div className="text-center mb-16" data-id="element-31">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-sage-light/30 text-sage-dark mb-4" data-id="element-32">
            <HelpCircle size={24} data-id="element-33" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-sage-dark" data-id="element-34">
            Common Questions
          </h2>
        </div>

        <div className="space-y-4" data-id="element-35">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-2xl border border-sage-light/20 overflow-hidden" data-id="element-36">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left hover:bg-gray-50 transition-colors" data-id="element-37">
                <span className="font-bold text-lg text-sage-dark pr-8" data-id="element-38">
                  {faq.q}
                </span>
                <motion.div animate={{
              rotate: openIndex === index ? 180 : 0
            }} transition={{
              duration: 0.2
            }} className="flex-shrink-0 text-sage-dark/50" data-id="element-39">
                  <ChevronDown size={20} data-id="element-40" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-41">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-42">
                    <div className="p-6 pt-0 text-sage-dark/80 leading-relaxed border-t border-dashed border-sage-light/20 mt-2" data-id="element-43">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}